
  "use strict";
  // const crypto = require("crypto");
  import converterWrapper from './converterWrapper'
  var rsaWrapper
  var crypto = window.crypto.subtle;
  const rsaParamsList = [
    { name: "RSA-OAEP", hash: { name: "SHA-256" } },
    { name: "RSA-OAEP", hash: { name: "SHA-1" } }
  ];

  function normalizeKeyMaterial(rawKey) {
    if (typeof rawKey !== "string") {
      throw new Error("RSA key should be a string");
    }

    let key = rawKey.trim();

    if (
      (key.startsWith('"') && key.endsWith('"')) ||
      (key.startsWith("'") && key.endsWith("'"))
    ) {
      key = key.substring(1, key.length - 1);
    }

    // Handle JSON-escaped PEM ("\\n") and mixed newline styles.
    key = key.replace(/\\r/g, "").replace(/\\n/g, "\n").replace(/\r/g, "");

    // If PEM, strip headers/footers first.
    if (key.indexOf("BEGIN ") > -1) {
      // Covers both multiline PEM and single-line PEM payloads.
      key = key
        .replace(/-----BEGIN [^-]+-----/g, "")
        .replace(/-----END [^-]+-----/g, "");

      // Fallback to legacy parser for odd formatting.
      if (key.indexOf("BEGIN ") > -1 || key.indexOf("END ") > -1) {
        key = converterWrapper.convertPemToBinary2(key);
      }
    }

    // Normalize base64url and whitespace.
    key = key.replace(/\s+/g, "").replace(/-/g, "+").replace(/_/g, "/");

    // Add base64 padding if missing.
    while (key.length % 4 !== 0) {
      key += "=";
    }

    return key;
  }

  function importKeyWithFallback(format, keyBuffer, keyUsages) {
    const tryImport = (index) => {
      if (index >= rsaParamsList.length) {
        return Promise.reject(new Error("Unable to import RSA key with supported OAEP hashes"));
      }

      const params = rsaParamsList[index];
      return crypto
        .importKey(format, keyBuffer, params, false, keyUsages)
        .catch(() => tryImport(index + 1));
    };

    return tryImport(0);
  }

  function importPublicKey(keyInPemFormat) {
    return new Promise(function(resolve, reject) {
      try {
        var key = normalizeKeyMaterial(keyInPemFormat);
        key = converterWrapper.base64StringToArrayBuffer(key);

        importKeyWithFallback("spki", key, ["encrypt"])
          .then(function(cryptokey) {
            resolve(cryptokey);
          })
          .catch(err => {
            reject(err);
          });
      } catch (err) {
        reject(err);
      }
    });
  }

  function importPrivateKey(keyInPemFormat) {
    return new Promise((resolve, reject) => {
      try {
        var key = normalizeKeyMaterial(keyInPemFormat);
        key = converterWrapper.base64StringToArrayBuffer(key);

        importKeyWithFallback("pkcs8", key, ["decrypt"])
          .then(function(cryptokey) {
            resolve(cryptokey);
          })
          .catch(err => {
            reject(err);
          });
      } catch (err) {
        reject(err);
      }
    });
  }

  function publicEncrypt(keyInPemFormat, message) {
    return new Promise(function(resolve, reject) {
      importPublicKey(keyInPemFormat)
        .then(function(key) {
          const tryEncrypt = (index) => {
            if (index >= rsaParamsList.length) {
              reject(new Error("Unable to encrypt message with supported OAEP hashes"));
              return;
            }

            crypto
              .encrypt(rsaParamsList[index], key, converterWrapper.str2abUtf8(message))
              .then(function(encrypted) {
                resolve(converterWrapper.arrayBufferToBase64String(encrypted));
              })
              .catch(() => tryEncrypt(index + 1));
          };

          tryEncrypt(0);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  function base64StringToArrayBuffer(b64str) {
    b64str = b64EncodeUnicode(b64str);
    var byteStr = atob(b64str);
    var bytes = new Uint8Array(byteStr.length);
    for (var i = 0; i < byteStr.length; i++) {
        bytes[i] = byteStr.charCodeAt(i);
    }
    return bytes.buffer;
    }
    
    
    function b64EncodeUnicode(str) {
        return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
            return String.fromCharCode('0x' + p1);
        }));
    }
  function privateDecrypt(keyInPemFormat, encryptedBase64Message) {
    return new Promise((resolve, reject) => {
      importPrivateKey(keyInPemFormat)
        .then(function(key) {
          const encryptedBuffer = converterWrapper.base64StringToArrayBuffer(
            encryptedBase64Message
          );
          const tryDecrypt = (index) => {
            if (index >= rsaParamsList.length) {
              reject(new Error("Unable to decrypt message with supported OAEP hashes"));
              return;
            }

            crypto
              .decrypt(rsaParamsList[index], key, encryptedBuffer)
              .then(function(decrypted) {
                resolve(converterWrapper.arrayBufferToUtf8(decrypted));
              })
              .catch(() => tryDecrypt(index + 1));
          };

          tryDecrypt(0);
        })
        .catch(err => reject(err));
    });
  }

  export default rsaWrapper = {
    importPrivateKey: importPrivateKey,
    importPublicKey: importPublicKey,
    privateDecrypt: privateDecrypt,
    publicEncrypt: publicEncrypt
  };

